import React, { useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { Navigate } from "react-router-dom";
import Loader from "../Components/Shared/Loader/loader";
import { b2cPolicies } from "./AuthConfig";

export const GetEarlyAccess = () => {
    const context = useMsal();
    const [state, setState] = useState({
        loading: true
    })

    useEffect(() => {
        // let category = this.props.location.search.substring(1);
        // category = decodeURIComponent(category);
        // localStorage.setItem("showOnBoarding", true);
        // localStorage.setItem("Category", category);
        setState({
            loading: false,
        })
    }, [])

    const redirect = () => {
        const loginRequest = {
            ...b2cPolicies.authorities.signUpSignIn,
            extraQueryParameters: {
                signup: true
            }
        }
        context.instance.loginRedirect(loginRequest);
    }

    if (state.loading) {
        return <Loader />;
    }

    if (context.inProgress !== "none") {
        return <Loader />;
    }
    if (context.accounts.length === 0) {
        redirect();
        return
    }

    return <Navigate to="/_Authorize" />;
}